import { MpFixedTabs } from './FixedTabs'
export default MpFixedTabs

export { MpFixedTabs, MpFixedTabsProps } from './FixedTabs'